import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useLlm } from '../../../useLlm/useLlm.js';

const Thread = () => {
  const {
    ChunkWrapper,
    Disclaimer,
    Feedback,
    Stream
  } = useLlm(state => state.components);
  const label = useLabel();
  const enableFeedback = useLlm(state => {
    var _a;
    return (_a = state.app) === null || _a === void 0 ? void 0 : _a.contents.enableFeedback;
  });
  const messages = useLlm(state => state.messages);
  const hasChunks = useLlm(state => state.chunks !== undefined);
  return jsxs("section", {
    className: "llm__thread llm__container",
    children: [messages.map((message, m) => jsxs("div", {
      className: getClassNames('llm__message', `llm__message--${message.role}`),
      role: "region",
      "aria-label": message.role === 'user' ? label('llm.question') : label('llm.answer'),
      children: [message.chunks.map((chunk, c) => jsx(ChunkWrapper, {
        className: `llm__inner llm__inner--${chunk.type}`,
        item: chunk,
        chunkIndex: c,
        index: m,
        total: messages.length,
        role: message.role
      }, `llm-message-${message.messageId}-chunk-${c}`)), message.role === 'user' ? m === 0 && jsx(Disclaimer, {}) : m === messages.length - 1 && enableFeedback && jsx(Feedback, {
        message: message
      })]
    }, `llm-message-${message.messageId}-${m}`)), hasChunks && jsx(Stream, {
      index: messages.length
    })]
  });
};

export { Thread };
//# sourceMappingURL=thread.js.map
